import React, { useContext } from "react";
import { TemplateContext } from "../../layout";
import { useCalculateProductCardPrice } from "../../func/orderCalculations.js";
import TagIcon from "../../utils/images/tagIcon";
import { motion } from "framer-motion";
import DiscountTagBlock from "../DiscountTagBlock.jsx";

const ProductCardVariant = ({ product, index, type, variant, amount }) => {
  const [templateContext, setTempalateContext] = useContext(TemplateContext);
  const warrantyLabel = window.post_template.checkout_v4_products.tr_checkout_v4_products_warrantyLabel;
  const discountAppliedLabel = window.post_template?.checkout_v4_summary?.tr_checkout_v4_discountApplied;
  const colorsData = window.productData?.product_color_variants;
  const variantObject = colorsData?.find((item) => {
    return item.value == variant.color;
  });
  const image = variantObject?.variant_image ? variantObject?.variant_image : product?.image?.url;

  const productPriceBlock = (amount) => {
    const { price, oldPrice, promoPrice } = useCalculateProductCardPrice(templateContext.config.product, amount);
    const formattedPrice = window.formattedString.replace(/(0\.00|0,00|0)/, price);
    const formattedPromoPrice = window.formattedString.replace(/(0\.00|0,00|0)/, promoPrice);

    return (
      <div className="productCard__priceBlock">
        <span className="productCard__priceBlock__oldPrice">{oldPrice}</span>
        {templateContext?.discountsEnabled && templateContext?.discountCode !== undefined ? (
          <span className="productCard__priceBlock__price">{formattedPromoPrice}</span>
        ) : (
          <span className="productCard__priceBlock__price">{formattedPrice}</span>
        )}
      </div>
    );
  };

  const { price, promoPrice } = useCalculateProductCardPrice(templateContext.config.product, amount);

  const DiscountAppliedBadge = (price, promoPrice) => {
    const additionalDiscount = (Number(price) - Number(promoPrice)).toFixed(2);
    const formattedDiscount = window.formattedString.replace(/(0\.00|0,00|0)/, additionalDiscount);

    return (
      <div className="productCard__titleBlock__tagText">
        <TagIcon />
        {templateContext.discountCode} {`(-${formattedDiscount})`}
      </div>
    );
  };

  return (
    <div key={index} className="productCard">
      <div className="productCard__imageContainer">
        <motion.div
          key={image}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 1,
            default: { duration: 0.5 },
          }}
        >
          <img src={image} alt={general_settings.brand_name} />
        </motion.div>
        <span className="productCard__imageContainer__indicator">{variant.amount}</span>
      </div>
      <div className="productCard__titleBlock">
        <div className="productCard__titleBlock__title">
          {product.display_name}{" "}
          {type !== "fake" && templateContext.config.warrantyState && <span>{warrantyLabel}</span>}
        </div>
        <p className="productCard__titleBlock__variant">
          <span>{variant.sizeLabel}</span> {variant.color && variant.size ? "/" : ""} <span>{variant.colorLabel}</span>
        </p>

        {window?.post_template?.checkout_v4_products?.checkout_v4_products_discountAppliedToggle && (
          <DiscountTagBlock discountAppliedLabel={discountAppliedLabel} />
        )}
        {product.tr_additional_texts && (
          <div className="productCard__titleBlock__altText">{product.tr_additional_texts}</div>
        )}

        {templateContext?.discountCode !== undefined &&
          templateContext.discountsEnabled &&
          DiscountAppliedBadge(price, promoPrice)}
      </div>
      {productPriceBlock(amount)}
    </div>
  );
};
export default ProductCardVariant;
